import ModalConfirm from 'general/components/Modal/ModalConfirm'
import AppResource from 'general/constants/AppResource'
import {
  getSidebarMenuItems,
  SIDEBAR_PERSONALINCOMETAX,
  SIDEBAR_TICKET_CONTENT,
} from 'general/constants/SidebarContent'
import Utils from 'general/utils/Utils'
import useRouter from 'hooks/useRouter'
import _ from 'lodash'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { shallowEqual, useSelector } from 'react-redux'
import '../style.scss'
import reportApi from 'api/reportApi'
import HoverPopover from './HoverPopover'
import { Tooltip } from 'antd'
import { ResourceExpiredPopup } from 'general/components/ResourceExpiredPopup'
import { useAppSelector } from 'hooks/useRedux'

let pathnameToNavigate = ''
const SideMenuContent = () => {
  const { t } = useTranslation()
  const { pathname, navigate } = useRouter()
  const partsName = pathname.split('/')
  const [showModalConfirm, setShowModalConfirm] = useState(false)
  const isCreateInvoicePage = useMemo(() => {
    return (
      partsName.includes('hoa-don') &&
      (partsName.includes('them-moi') ||
        partsName.includes('dieu-chinh') ||
        partsName.includes('thay-the') ||
        partsName.includes('dieu-chinh') ||
        partsName.includes('cap-nhat'))
    )
  }, [partsName])

  const { invoice, ticket, personalIncomeTax } = useSelector(
    (s) => s.auth.activeInvoice,
  )
  const packageExpire = useAppSelector(
    (state) => state.auth.package,
    shallowEqual,
  )

  async function previewFile(code) {
    const response = await reportApi.downloadFilePublic({ code, type: 'file' })
    console.log('response', response)
    const blob = new Blob([response], { type: 'application/pdf' })
    const url = URL.createObjectURL(blob)
    window.open(url, '_blank') // Xem PDF online
  }

  // fix value follow by labelKey config in SidebarContent.js
  const [showLabelState, setShowLabelState] = useState({ systemWarning: true })

  const { company } = useSelector((state) => state?.system)

  /**
   * @param {SidebarContent} menu
   * @param {number} idx
   */
  const renderMenuItems = (menu, idx) => {
    if (menu?.type === 'item') {
      const hasSubMenuItems = !!menu?.subMenuItems
      const tabIsActive = _.isEqual(pathname, menu.path)

      return (
        <li
          key={`menu_${menu?.text}_item_${idx}`}
          className={`menu-item ${hasSubMenuItems ? 'menu-item-submenu' : ''} ${
            tabIsActive ? 'menu-item-active' : ''
          }
          `
            .trim()
            .replace(/\s/g, ' ')}
        >
          <a
            href={menu?.path}
            onClick={(e) => {
              if (menu?.label && menu.subMenuItems) {
                // phải có cấu hình label và có subMenuItems mới toggle
                e.preventDefault()
                setShowLabelState((prev) => ({
                  ...prev,
                  [menu?.label?.labelKey]: !prev[menu?.label?.labelKey],
                }))
              }
              if (Utils.isObjectEmpty(menu.subMenuItems)) {
                if (menu.isDownload) {
                  if (menu.api) {
                    previewFile('HDSD_CT_ THUE_TNCN')
                  } else {
                    e.preventDefault()
                    window.open(menu?.path, '_blank')
                    return
                  }
                }
                if (menu?.path) {
                  e.preventDefault()
                  if (isCreateInvoicePage) {
                    setShowModalConfirm(true)
                    pathnameToNavigate = menu?.path
                    return
                  }
                  navigate(menu?.path)
                }
              }
            }}
            className={`menu-link ${hasSubMenuItems ? 'menu-toggle' : ''}`}
          >
            {menu.icon ? (
              <span className="sgv-icon menu-icon">
                <i className={menu?.icon}></i>
              </span>
            ) : (
              <i className="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
            )}

            <span className="menu-text">{t(menu?.text)}</span>

            {menu?.label?.isShow && (
              <span className="menu-label" style={{ marginLeft: 6 }}>
                {/* label label-rounded label-inline label-danger */}
                <span className="">
                  <Tooltip
                    title={
                      <ResourceExpiredPopup
                        packageExpire={packageExpire}
                        navigate={navigate}
                      />
                    }
                    placement="topRight"
                    // align={{ offset: [0, 20] }}
                    color="#fff"
                    // overlayInnerStyle={{ color: '#000' }}
                  >
                    {menu.label?.text}
                  </Tooltip>
                </span>
              </span>
            )}

            {hasSubMenuItems && <i className="menu-arrow" />}
          </a>
          {hasSubMenuItems ? (
            <div className="menu-submenu">
              <ul className="menu-subnav">
                {/* Using flatMap */}
                {menu.subMenuItems
                  .filter((root) => !!root)
                  .map(renderMenuItems)}

                {/* {menu.subMenuItems
                  .filter((item) => item !== null)
                  .map((root, rootIdx) => renderMenuItems(root, rootIdx))} */}
              </ul>
            </div>
          ) : null}
        </li>
      )
    } else {
      return (
        <li
          key={`menu_${menu?.text}_item_${idx}`}
          className="menu-section mt-0"
        >
          <h4
            className="menu-text"
            style={{
              color: AppResource.colors.feature,
            }}
          >
            {t(menu?.text)}
          </h4>
        </li>
      )
    }
  }
  const SIDEBAR_MENU_ITEMS = useMemo(
    () =>
      getSidebarMenuItems({
        isPackageExpired: packageExpire?.warning || packageExpire?.expired,
        labels: showLabelState,
      }),
    [packageExpire, showLabelState],
  )
  return (
    <>
      {!company?.taxCode ? (
        <></>
      ) : company.taxCode === process.env.REACT_APP_SUPER_ADMIN_TAX_CODE ? (
        <ul className="menu-nav pt-0">
          {[
            {
              type: 'item',
              text: 'Hệ thống',
              icon: 'fa-regular fa-gear',
              path: '/hoa-don-dau-ra/he-thong/xu-ly-tvan',
            },
            {
              type: 'item',
              text: 'Doanh nghiệp',
              icon: 'fa-regular fa-gear',
              path: '/hoa-don-dau-ra/he-thong/xu-ly-tvan/doanh-nghiep',
            },
            {
              type: 'item',
              text: 'Chứng từ',
              icon: 'fa-regular fa-gear',
              path: '/hoa-don-dau-ra/he-thong/xu-ly-tvan/chung-tu',
            },
          ].map(renderMenuItems)}
        </ul>
      ) : (
        <ul className="menu-nav pt-0">
          {invoice
            ? SIDEBAR_MENU_ITEMS.map(renderMenuItems)
            : ticket
              ? SIDEBAR_TICKET_CONTENT.map(renderMenuItems)
              : personalIncomeTax
                ? SIDEBAR_PERSONALINCOMETAX.map(renderMenuItems)
                : null}
        </ul>
      )}

      <ModalConfirm
        header="Xác nhận"
        content="Bạn chưa lưu dữ liệu. Bạn có muốn tiếp tục không"
        show={showModalConfirm}
        setShow={setShowModalConfirm}
        handleConfirm={(e) => {
          e.preventDefault()
          setShowModalConfirm(false)
          if (pathnameToNavigate === '/hoa-don-dau-ra/hoa-don/them-moi') {
            window.location.href = '/hoa-don-dau-ra/hoa-don/them-moi'
          } else {
            navigate(pathnameToNavigate)
          }
        }}
      />
    </>
  )
}

export default SideMenuContent
